import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; 
import {
  FaBookOpen,
  FaCode,
  FaFileInvoiceDollar,
  FaUniversalAccess,
  FaLaptopCode
} from "react-icons/fa";
import "./Services.css";
import bannerImg from "../uploads/pexels-pixabay-273209.jpg"
function Services() {
  const [selectedService, setSelectedService] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.toggle("card-modal-open", Boolean(selectedService));

    return () => {
      document.body.classList.remove("card-modal-open");
    };
  }, [selectedService]);

  const services = [
    {
      icon: <FaBookOpen />,
      title: "ePUB Conversion & Digital Publishing",
      short: "Professional eBook conversion & publishing workflows.",
      full: `
We provide seamless eBook conversion and publishing workflows tailored to global standards.

• Accurate formatting and validation
• Cross-platform compatibility
• Metadata structuring
• Quality assurance and compliance

Our solutions enable publishers to distribute content efficiently across all major digital platforms.
      `
    },
    {
      icon: <FaCode />,
      title: "XML Content Services",
      short: "Structured content transformation using XML workflows.",
      full: `
We specialize in structured content transformation and management.

• Content structuring and tagging
• DTD / Schema validation
• Content migration and transformation
• Workflow automation
      `
    },
    {
      icon: <FaFileInvoiceDollar />,
      title: "Intelligent Invoice Processing",
      short: "Automated invoice solutions for efficiency.",
      full: `
Our automated invoice processing improves speed and accuracy.

• Data extraction & validation
• Workflow automation
• Error reduction
• Secure processing
      `
    },
    {
      icon: <FaUniversalAccess />,
      title: "PDF Accessibility & Compliance",
      short: "Accessible and compliant digital documents.",
      full: `
We ensure digital documents meet accessibility standards.

• PDF remediation
• WCAG compliance
• Screen reader compatibility
• Structure optimization
      `
    },
    {
      icon: <FaLaptopCode />,
      title: "IT & Digital Transformation",
      short: "Scalable technology solutions for business growth.",
      full: `
We deliver tailored technology solutions.

• Web development
• Process automation
• Workflow optimization
• Custom integrations
      `
    }
  ];

  const renderContent = (text) => {
    const lines = text.split("\n").filter(line => line.trim() !== "");

    return lines.map((line, index) => {
      if (line.trim().startsWith("•")) {
        return <li key={index}>{line.replace("•", "").trim()}</li>;
      }
      return <p key={index}>{line.trim()}</p>;
    });
  };

  return (
    <div className="services-wrapper">

      <section className="services-banner">
        <img src={bannerImg} alt="banner" />
        <div className="banner-overlay">
          <h1>Our Services</h1>
          <p>
            Smart, scalable and future-ready digital solutions designed to accelerate growth.
          </p>
        </div>
      </section>

      <section className="services-icons-row">
        {services.map((service, index) => (
          <div
            key={index}
            className="icon-card"
            onClick={() => setSelectedService(service)}
          >
            <div className="icon-circle">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.short}</p>
          </div>
        ))}
      </section>

     
      {selectedService && (
        <div
          className="modal-overlay"
          onClick={() => setSelectedService(null)}
        >
          <div
            className="modern-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <div className="modal-title-section">
                <div className="modal-icon">{selectedService.icon}</div>
                <h2>{selectedService.title}</h2>
              </div>

              <button
                className="close-btn"
                onClick={() => setSelectedService(null)}
              >
                ✕
              </button>
            </div>

            <div className="modal-body">
              <ul className="feature-list">
                {renderContent(selectedService.full)}
              </ul>
            </div>

            <div className="modal-footer">
            
              <button
                className="cta-btn"
                onClick={() =>
                  navigate("/contact", {
                    state: { service: selectedService.title }
                  })
                }
              >
                Get This Service →
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default Services;
